import React from 'react';
import { Link } from 'react-router-dom';
import { FiSettings, FiDatabase, FiUserPlus, FiList, FiTool } from 'react-icons/fi';
import { useWorkspace } from '../../context/WorkspaceContext';

const WorkspaceHubPage: React.FC = () => {
  const { buildUrl } = useWorkspace();

  const sections = [
    { path: buildUrl({ kind: 'settings' }), icon: FiSettings, label: 'Settings', description: 'Workspace configuration and preferences' },
    { path: buildUrl({ kind: 'data-sources' }), icon: FiDatabase, label: 'Data Sources', description: 'External integrations and imports' },
    { path: buildUrl({ kind: 'invitations' }), icon: FiUserPlus, label: 'Invitations', description: 'Invite users and manage invite links' },
    { path: buildUrl({ kind: 'history' }), icon: FiList, label: 'History', description: 'View all changes made to this workspace' },
    { path: buildUrl({ kind: 'tools' }), icon: FiTool, label: 'Tools', description: 'Analysis and maintenance utilities' },
  ];

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-mono font-semibold text-cm-text-primary">Workspace</h1>
        <p className="mt-1 text-sm text-cm-text-secondary">
          Workspace administration and configuration.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {sections.map(({ path, icon: Icon, label, description }) => (
          <Link
            key={path}
            to={path}
            className="rounded-xl border border-cm-border-subtle bg-cm-bg-surface p-5 hover:border-cm-accent-orange transition-colors group"
          >
            <Icon className="w-6 h-6 text-cm-accent-blue mb-3" />
            <h3 className="font-mono font-medium text-cm-text-primary group-hover:text-cm-accent-orange transition-colors">{label}</h3>
            <p className="text-sm text-cm-text-muted mt-1">{description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default WorkspaceHubPage;
